/** The two catalog lenses on the Integrations home. Filled in by CT-4158 (Tab Strip). */
export const INTEGRATIONS_TABS = {
  ALREADY_INTEGRATED: 'already-integrated',
  MARKETPLACE: 'marketplace',
};

export const DEFAULT_INTEGRATIONS_TAB = INTEGRATIONS_TABS.ALREADY_INTEGRATED;

/** Tab definitions (order = display order). `labelKey` resolves in the `admin-studio` namespace. */
export const INTEGRATIONS_TAB_LIST = [
  { id: INTEGRATIONS_TABS.ALREADY_INTEGRATED, labelKey: 'integrations.home.tabs.alreadyIntegrated' },
  { id: INTEGRATIONS_TABS.MARKETPLACE, labelKey: 'integrations.home.tabs.marketplace' },
];
